import { Component, Prop, Vue } from 'vue-property-decorator';
import { Chain } from 'ignite360-core';

@Component
export class ChainMixin extends Vue {
  @Prop({ required: true, type: Object })
  readonly chain!: Chain;
}
